export default function (store, target, toLowerCase) {

  if (typeof toLowerCase === "undefined") {
    toLowerCase = false
  }

  if (target.constructor === Array) {
    if (target.length === 1) {
      return {
        get () {
          return store.state.signUpState.recorded[target[0]]
        },
        set (val) {
          store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
            target: target,
            value: typeof val === "string" ? toLowerCase ? val.trim().toLowerCase():val.trim():val
          })
        }
      }
    }
    if (target.length === 2) {
      return {
        get () {
          return store.state.signUpState.recorded[target[0]][target[1]]
        },
        set (val) {
          store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
            target: target,
            value: typeof val === "string" ? toLowerCase ? val.trim().toLowerCase():val.trim():val
          })
        }
      }
    }
    if (target.length === 3) {
      return {
        get () {
          return store.state.signUpState.recorded[target[0]][target[1]][target[2]]
        },
        set (val) {
          store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
            target: target,
            value: typeof val === "string" ? toLowerCase ? val.trim().toLowerCase():val.trim():val
          })
        }
      }
    }
    if (target.length === 4) {
      return {
        get () {
          return store.state.signUpState.recorded[target[0]][target[1]][target[2]][target[3]]
        },
        set (val) {
          store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
            target: target,
            value: typeof val === "string" ? toLowerCase ? val.trim().toLowerCase():val.trim():val
          })
        }
      }
    }
  } else {
    return {
      get () {
        return store.state.signUpState.recorded[target]
      },
      set (val) {
        store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
          target: target,
          value: typeof val === "string" ? toLowerCase ? val.trim().toLowerCase():val.trim():val
        })
      }
    }
  }
}
